import { css } from '@/styled-system/css';

export const truncatedTextStyles = css.raw({
  display: 'inline-block',
  overflowX: 'hidden',
  textOverflow: 'ellipsis',
  verticalAlign: 'bottom',
  whiteSpace: 'nowrap',
});
